var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"about-page"},[_c('AboutPageHero'),_c('AboutPageWhoWeAre'),_c('AboutWeThink'),_c('AboutPageOurProjects'),_c('AboutPageMainDirections'),_c('AboutPageCeo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }